module.exports = __webpack_public_path__ + "static/media/generali-logo.88c55236.svg";